<template>
    <div>
        <div class="base-wrapper" v-if="accepted">
            <div class="uk-card">
                <div class="uk-card-header">
                    <h3>Add/Edit Videos and questions</h3>
                </div>
                <button class="uk-button uk-button-primary" @click="new_video_modal = true">Add Video</button>
                <div class="uk-card-body">
                    <b-collapse
                        class="card"
                        animation="slide"
                        v-for="v in all_videos"
                        :key="v.id"
                        :open="video_details == v.id"
                        @open="video_details = v.id">
                        <div
                            slot="trigger"
                            slot-scope="props"
                            class="card-header"
                            role="button">
                            <p class="card-header-title">{{ v.name }}</p>
                        </div>
                        <div class="card-content uk-flex">
                            <div style="width: 350px">
                                <video uk-video controls style="margin: 10px 0">
                                    <source :src="v.video_url" />
                                </video>
                                <div v-if="edit_video == v.id">
                                    <br>
                                    <b-field label="Video Name">
                                        <b-input v-model="v.name"></b-input>
                                    </b-field>
                                    <b-field label="Video URL">
                                        <b-input v-model="v.video_url"></b-input>
                                    </b-field>
                                    <br>
                                </div>

                                <button v-if="edit_video != v.id" class="uk-button uk-button-primary" @click="edit_video = v.id">Edit</button>
                                <button v-if="edit_video == v.id" class="uk-button uk-button-primary" @click="editVideoSave(v.id)">Save</button>
                                <button v-if="edit_video == v.id" class="uk-button uk-button-default" @click="cancelVideoEdit">Cancel</button>
                                <button class="uk-button uk-button-danger" @click="deleteVideo(v.id)">Delete</button>
                            </div>
                            <div class="questions uk-flex-auto uk-padding-small uk-margin-small">
                                <div
                                    class="question uk-text-left"
                                    v-for="(q, index) in v.follow_up_questions"
                                    :key="index"
                                    @mouseenter="video_hover = v.id + '-' + index"
                                    @mouseleave="video_hover = null">
                                    <p v-if="edit_video_questions != v.id + '-' + index">
                                        <b>{{ q.question }}</b>
                                        <a v-show="video_hover == v.id + '-' + index"
                                           @click="edit_video_questions = v.id + '-' + index"
                                           style="font-size: 12px">Edit Question</a></p>
                                    <p v-else><i>Edit mode</i></p>
                                    <b-field v-if="edit_video_questions == v.id + '-' + index" label="Question">
                                        <b-input v-model="q.question"></b-input>
                                    </b-field>
                                    <ul class="uk-list uk-list-divider">
                                        <li v-for="(a, a_index) in q.possible_answer"
                                            :key="a_index">
                                            <div v-if="edit_video_questions != v.id + '-' + index">{{ a.answer }}<br><i class="uk-text-small" :style="{'color': a.correct ? 'green' : 'red'}">{{ a.correct ? 'Correct' : 'Wrong' }}</i></div>
                                            <div v-else>
                                                <b-field label="Answer Option">
                                                    <b-input v-model="a.answer"></b-input>
                                                </b-field>
                                                <b-field label="Correct">
                                                    <b-checkbox v-model="a.correct"></b-checkbox>
                                                </b-field>
                                                <button class="uk-button uk-button-danger" @click="q.possible_answer.splice(a_index, 1)">Remove</button>
                                            </div>
                                        </li>
                                        <li v-if="edit_video_questions == v.id + '-' + index"><button class="uk-button uk-button-primary" @click="q.possible_answer.push({answer: '', correct: false})">Add Option</button></li>
                                    </ul>
                                    <div v-if="edit_video_questions == v.id + '-' + index" style="margin: 5px 0">
                                        <button class="uk-button uk-button-primary" @click="saveQuestion">Save</button>
                                        <button class="uk-button uk-button-default" @click="cancelEdit">Cancel</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </b-collapse>

                </div>
            </div>
        </div>
        <b-modal :active.sync="new_video_modal"
                 has-modal-card
                 role="dialog">
            <div class="modal-card">
                <div class="modal-card-head"><p class="modal-card-title">New Video</p></div>
                <div class="modal-card-body uk-text-left">
                    <b-field label="Video Name">
                        <b-input v-model="new_video_details.name"></b-input>
                    </b-field>
                    <b-field label="Video URL">
                        <b-input v-model="new_video_details.video_url"></b-input>
                    </b-field>
                    <b-field label="Video has expiration?">
                        <b-checkbox v-model="new_video_static"></b-checkbox>
                    </b-field>
                    <b-field v-if="new_video_static" label="Start">
                        <b-datepicker v-model="new_video_details.display_start"></b-datepicker>
                    </b-field>
                    <b-field v-if="new_video_static" label="End">
                        <b-datepicker v-model="new_video_details.display_end"></b-datepicker>
                    </b-field>
                    <div  v-for="(q, index) in new_video_details.follow_up_questions" :key="index">
                        <b-field style="width: 100%" label="Question">
                            <b-input
                                v-model="q.question"
                                type="textarea"></b-input>
                        </b-field>
                            <div v-for="(a, a_index) in q.possible_answer" :key="a_index">
                                <b-field label="Possible Answer">
                                    <b-input v-model="a.answer"></b-input>
                                </b-field>
                                <b-field label="Answer Correct">
                                    <b-checkbox v-model="a.correct"></b-checkbox>
                                </b-field>
                            </div>
                            <button
                                @click="q.possible_answer.push({answer: '', correct: false})"
                                class="uk-button uk-button-primary uk-button-small">Add Answer</button><br>
                    </div>
                    <button class="uk-button uk-button-primary" style="margin: 10px 0" @click="new_video_details.follow_up_questions.push({question: '', possible_answer: []})">Add Question</button>
                </div>
                <div class="modal-card-foot">
                    <button class="uk-button uk-button-primary" @click="addNewVideo">Submit</button>
                </div>
            </div>
        </b-modal>
    </div>
</template>

<script>
    import findIndex from 'lodash/findIndex'
    import apicall from "../store/apicall";
    import moment from 'moment'
    export default {
        name: "TrainingVideos",
        data() {
            return {
                accepted: null,
                video_details: null,
                video_hover: null,
                edit_video: null,
                edit_video_questions: null,
                add_video_question: null,
                new_video_modal: false,
                new_video_details: {
                    'name': '',
                    'video_url': '',
                    'display_start': new Date(),
                    'display_end': new Date(),
                    'follow_up_questions': []
                },
                new_video_static: false,
                all_videos: null
            }
        },
        methods: {
            isAccpeted() {
                let permission = this.$store.state.user.data.permission;
                let idx = findIndex(permission, {'name': 'beta'})
                if (idx >= 0) {
                    this.accepted = true
                } else {
                    window.location = '/'
                }
                return
            },
            saveQuestion() {
                this.edit_video_questions = null
            },
            cancelEdit() {
                this.edit_video_questions = null
            },
            getAllQuestions() {
                apicall.post('/training/', {
                    'purpose': 'questions',
                    'parameters': {
                        'action': 'get_questions'
                    }}).then(res => {
                        this.all_videos = res.data
                    })
            },
            addNewVideo() {
                let date_range = {};
                if (this.new_video_static === false) {
                    date_range = null
                } else {
                    date_range.start = moment(this.new_video_details.display_start).format('YYYY-MM-DD')
                    date_range.end = moment(this.new_video_details.display_end).format('YYYY-MM-DD')
                }
                let request = {
                    'purpose': 'questions',
                    'parameters': {
                        'action': 'new_video',
                        'video_details': {
                            'name': this.new_video_details.name,
                            'video_url': this.new_video_details.video_url,
                            'date_range': date_range,
                        },
                        'questions': this.new_video_details.follow_up_questions
                    }
                }
                apicall.post('/training/', request)
                    .then(res => {
                        this.all_videos.push(res.data)
                        this.new_video_details = {
                            'name': '',
                            'video_url': '',
                            'display_start': new Date(),
                            'display_end': new Date(),
                            'follow_up_questions': []
                        }
                        this.$buefy.toast.open({
                            message: 'Saved!',
                            type: 'is-success'
                        })
                    })
            },
            editVideo(video_id) {

            },
            editVideoSave(video_id) {

            },
            deleteVideo(video_id) {

            },
            cancelVideoEdit() {
                this.edit_video = null
                this.$buefy.snackbar.open({
                    message: "Nothing was saved. If you refresh the page, all changes with go back to it's previous state.",
                    type: 'is-danger'
                })
            }
        },
        mounted() {
            this.isAccpeted()
            this.getAllQuestions()
        }
    }
</script>

<style scoped>
    .modal {
        z-index: 1000;
    }
</style>
